import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=16da38dc&"
import script from "./LabelInput.vue?vue&type=script&lang=js&"
export * from "./LabelInput.vue?vue&type=script&lang=js&"
import style0 from "./LabelInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports